import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resolveUsageScreen } from "../helpers/usageScreens";
import { trackScreen } from "../services/usageTrackingService";

/**
 * Registra as telas vistas pelo usuário logado (uso por funcionalidade, lido
 * pelo BackOffice). Montado no Layout autorizado; as ações feitas são
 * registradas pelo próprio Backend.
 */
export const useScreenUsageTracking = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackScreen(resolveUsageScreen(pathname, search), pathname);
  }, [pathname, search]);
};
